import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '../../auth/user.model';
import { Material, Order, Size } from '../order.model';
import { Subscription } from 'rxjs/index';
import { OrderService } from '../order.service';
import { AuthService } from '../../auth/auth.service';
import { UIService } from '../../shared/ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';


@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({backgroundColor: 'yellow', opacity: 0, height: '0px'}),
        animate(2000)
      ])
    ])
  ]
})

export class OrderDetailsComponent implements OnInit, OnDestroy {
  user: User;
  order: Order;
  isLoading = false;
  addressFormGroup: FormGroup;
  binFormGroup: FormGroup;
  deliveryDateFormGroup: FormGroup;

  selectedMaterialReview = 'Aucun';
  selectedBinSizeReview = 'Aucun';
  addressReview = 'Aucun'
  deliveryDateReview = 'Aucun';


  lat: number = 51.678418;
  lng: number = 7.809007;
  daysComplete = {
    '2019': [181, 182, 183, 151, 146, 21],
    '2020': [152, 136, 121]
  };

  materials = [];
  binSizes = [];
  binSizesFull = [];
  binSizesHeavy = [];

  now = moment();


  private loadingSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private authentication: AuthService,
    private uiService: UIService,
    private _formBuilder: FormBuilder,
    private _ref: ChangeDetectorRef
  ) { }

  minimumDate = this.now.add(3, 'days');

  myFilter = (momentDate: moment.Moment): boolean => {
    const day = momentDate.day();
    if (day === 0 || day === 6) {
      console.log('is sunday or saturday');
      return false;
    }
    const dayOfYear = momentDate.dayOfYear();
    const year = momentDate.year();
    const dayCompleteList =  this.daysComplete[year];

    if (dayCompleteList !== undefined && dayCompleteList.indexOf(dayOfYear) !== -1) {
      console.log('in list');
      return false;
    }
    return true;
  };

  setAddress(event) {
    console.log(event);
    this.lat = event.geometry.location.lat();
    this.lng = event.geometry.location.lng();
    this._ref.detectChanges();
  }

  ngOnInit() {

    this.addressFormGroup = this._formBuilder.group({
      address: ['', Validators.required]
    });

    this.deliveryDateFormGroup = this._formBuilder.group({
      deliveryDate: [{disabled: true}, Validators.required]
    });

    this.binFormGroup = this._formBuilder.group({
      material: ['', Validators.required],
      size_wanted: ['', Validators.required],
      delivery_comments: ['']
    });

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.user = this.authentication.getUser();

    this.getMaterials();
    this.getBinSizes();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      console.log(id);
      this.orderService.getOrderById(this.user.token, id).subscribe((res: Order) => {
        this.order = res;
        this.lat = this.order.latitude;
        this.lng = this.order.longitude;
        this.addressFormGroup.setValue({address: this.order.address});
        this.deliveryDateFormGroup.setValue({deliveryDate: moment(this.order.delivery_date)});
        this.setBinSizesByMaterialId(this.order.material.id);
        this.binFormGroup.setValue({
          size_wanted: this.order.size_wanted.id,
          material: this.order.material.id
        });
        this.uiService.loadingStateChanged.next(false);
      });
    });
  }

  getMaterials() {
    this.orderService.getMaterials(this.user.token).subscribe((response: [Material]) => {
      this.materials = response;
      this.uiService.loadingStateChanged.next(false);
    });
  }

  getBinSizes() {
    this.orderService.getBinsizes(this.user.token).subscribe((response: [Size]) => {
      this.createSizesFiltered(response);
      this.uiService.loadingStateChanged.next(false);
    });
  }

  createSizesFiltered(binSizes) {
    const largeBinIds = [1, 2, 5, 6];
    for (const binSize of binSizes) {
      let formattedBinSizes = {
        'id': binSize.id,
        'name': binSize.name,
        'disabled': false
      };
      this.binSizesFull.push(formattedBinSizes);

      if (largeBinIds.includes(binSize.id)) {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name + ' ( Trop lourd )',
          'disabled': true
        };
      } else {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name,
          'disabled': false
        };
      }
      this.binSizesHeavy.push(formattedBinSizes);
    }
  }

  setBinSizesByMaterialId(selectedMaterialId) {
    const heavyMaterialIds = [1, 5, 6, 10];
    if (heavyMaterialIds.includes(selectedMaterialId)) {
      this.binSizes = this.binSizesHeavy;
    } else {
      this.binSizes = this.binSizesFull;
    }
  }

  getSelectedMaterial() {
    const lookingForId = this.binFormGroup.value.material;
    for (const material of this.materials) {
      if (material.id === lookingForId) {
        return material.name;
      }
    }
    return 'Aucun';
  }

  getSelectedBinSize() {
    const lookingForId = this.binFormGroup.value.size_wanted;
    for (const size of this.binSizes) {
      if (size.id === lookingForId) {
        return size.name;
      }
    }
    return 'Aucun';
  }

  onSelectionChange(event) {
    console.log(event);
    if (event.selectedIndex === 3) {
      this.selectedBinSizeReview = this.getSelectedBinSize();
      this.selectedMaterialReview = this.getSelectedMaterial();
      this.deliveryDateReview = this.deliveryDateFormGroup.value.deliveryDate;
      this.addressReview = this.addressFormGroup.value.address;
    }
  }

  onMaterialSelectionChanged(event) {
    const selectedMaterialId = event.value;
    this.setBinSizesByMaterialId(selectedMaterialId);
    this.binFormGroup.setValue({size_wanted: null, material: selectedMaterialId});
  }

  createOrUpdateOrder() {
    let orderId = -1;
    if (this.order !== undefined && this.order.id !== undefined) {
      orderId = this.order.id;
    }
    /*
    const orderReservation: OrderReservation = {
        'address': this.addressFormGroup.value.address,
        'id': orderId,
        'longitude': this.lng,
        'latitude': this.lat,
        'delivery_date': this.deliveryDateFormGroup.value.deliveryDate.toJSON(),
        'size_wanted': this.binFormGroup.value.size_wanted,
        'material': this.binFormGroup.value.material
      };

    if (this.order === undefined) {
      this.orderService.createOrder(this.user.token, orderReservation).subscribe((response: OrderReservation) => {
        this.uiService.loadingStateChanged.next(false);
        this.router.navigate(['/reservations']);
      });
    } else {
      this.orderService.updateOrder(this.user.token, orderReservation).subscribe((response: OrderReservation) => {
        this.uiService.loadingStateChanged.next(false);
        this.router.navigate(['/reservations']);
      });
    }*/
    console.log(this.order);
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
  }
}
